import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import React, { useState } from "react";

type ScrollDownIndicatorProps = {
  targetId: string;
  className?: string;
};

const ScrollDownIndicator: React.FC<ScrollDownIndicatorProps> = ({
  targetId,
  className,
}) => {
  const [hovered, setHovered] = useState(false);

  const scrollToTarget = () => {
    const el = document.getElementById(targetId);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setHovered(false);
  };

  return (
    <motion.div
      onClick={scrollToTarget}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      initial={{ y: 0 }}
      animate={{ y: [0, 5, 0] }}
      transition={{
        duration: 1.8,
        repeat: Infinity,
        ease: "easeInOut" as const,
      }}
      className={`overflow-hidden flex  justify-center cursor-pointer rounded-full backdrop-blur-sm border border-white text-white shadow-md ${className}`}
    >
      <motion.div
        animate={{
          width: hovered ? 120 : 40,
          height: 40,
          borderRadius: hovered ? 999 : 999,
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        }}
        transition={{ duration: 0.3, ease: "easeInOut" as const }}
        className="flex items-center justify-center px-4"
      >
        {!hovered ? (
          // Chevron animation when not hovered
          <div className="relative flex flex-col items-center justify-center p-1">
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: [0, 1, 1, 0], y: [-10, 0, 8, 16] }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut" as const,
                times: [0, 0.25, 0.75, 1],
              }}
            >
              <ChevronDown size={22} />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: [0, 0, 1, 0], y: [-10, -10, 0, 12] }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut" as const,
                times: [0, 0.25, 0.75, 1],
              }}
              className="-mt-1"
            >
              <ChevronDown size={22} />
            </motion.div>
          </div>
        ) : (
          // Scroll Text on hover
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="text-sm font-medium"
          >
            Scroll
          </motion.span>
        )}
      </motion.div>
    </motion.div>
  );
};

export default ScrollDownIndicator;
